import * as React from 'react'
import { Paper, Grid, Typography, Modal } from '@material-ui/core';


type Props = {
    title: string,
    message?: () => React.ReactElement,
    customButtonsContent?: () => React.ReactElement,
    customContent?: React.ReactElement,
    open: boolean,
    minWidth?: string,
}

export class QmoModal extends React.PureComponent<Props>{
    render() {
        return (
            <Modal open={this.props.open}>

                <Paper
                    id="qmo-modal"
                    style={{
                        position: 'absolute',
                        minWidth: this.props.minWidth || '325px',
                        outline: 'none',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        padding: '25px',
                        borderRadius: "25px"
                    }}>

                    {this.props.customContent ?
                        <div>
                            {this.props.title &&
                                <>
                                    <Typography variant="h4">{this.props.title}</Typography>
                                    <hr></hr>
                                </>
                            }
                            {this.props.customContent}
                        </div>
                        :
                        <Grid container>
                            <Grid item xs={12} sm={12}>
                                <Typography variant="h4">{this.props.title}</Typography>
                                <hr></hr>
                            </Grid>
                            <Grid item xs={12} sm={12} style={{ paddingBottom: "15px", paddingTop: "15px", textAlign: "center" }}>
                                <Typography>{this.props.message!()}</Typography>
                            </Grid>

                            {this.props.customButtonsContent!()}
                        </Grid>

                    }
                </Paper>
            </Modal>
        )
    }
}


type SimpleMessageProps = {
    title: string,
    message: () => React.ReactElement,
    customButtonsContent: () => React.ReactElement,
    open: boolean
}


export class SimpleMessageQmoModal extends React.PureComponent<SimpleMessageProps>{
    render() {
        return (
            <QmoModal open={this.props.open} title={this.props.title} message={this.props.message} customButtonsContent={this.props.customButtonsContent}></QmoModal>
        )
    }
}
